import React from 'react'

export function ChevronRightIcon() {
  return (
    <svg width="9" height="14" viewBox="0 0 9 14" fill="none">
      <path d="M8.02677 7.69307L2.00699 13.7127C1.62406 14.0958 1.0032 14.0958 0.620456 13.7127C0.23768 13.3299 0.23768 12.7091 0.620456 12.3263L5.94703 6.9999L0.620611 1.67367C0.237835 1.29074 0.237835 0.669973 0.620611 0.287198C1.00339 -0.0957326 1.62421 -0.0957326 2.00714 0.287198L8.02693 6.30688C8.21831 6.49836 8.3139 6.74905 8.3139 6.99987C8.3139 7.25081 8.21813 7.50168 8.02677 7.69307Z" fill="white"/>
    </svg>
  )
}

export function ChevronLeftIcon() {
  return (
    <svg width="9" height="15" viewBox="0 0 9 15" fill="none">
      <path d="M0.866904 6.80693L6.88669 0.787337C7.26962 0.404221 7.89047 0.404221 8.27322 0.787337C8.656 1.17011 8.656 1.79094 8.27322 2.17368L2.94664 7.5001L8.27307 12.8263C8.65584 13.2093 8.65584 13.83 8.27307 14.2128C7.89029 14.5957 7.26946 14.5957 6.88653 14.2128L0.866749 8.19312C0.675361 8.00164 0.579775 7.75095 0.579775 7.50013C0.579775 7.24919 0.675547 6.99832 0.866904 6.80693Z" fill="#007BFF"/>
     </svg>
  )
}

export function ChevronUpIcon() {
  return (
    <svg width="14" height="9" viewBox="0 0 14 9" fill="none">
      <path d="M7.69307 0.97326L13.7127 6.99304C14.0958 7.37597 14.0958 7.99683 13.7127 8.37957C13.3299 8.76235 12.7091 8.76235 12.3263 8.37957L6.9999 3.053L1.67367 8.37942C1.29074 8.7622 0.669973 8.7622 0.287198 8.37942C-0.0957327 7.99664 -0.0957327 7.37582 0.287198 6.99289L6.30688 0.973105C6.49836 0.781717 6.74905 0.686131 6.99987 0.686131C7.25081 0.686131 7.50168 0.781903 7.69307 0.97326Z" fill="white"/>
    </svg>
  )
}